import { Checkbox, Table, Text, Tooltip } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import type { TableHeaderProps } from "./types";

/**
 * Table header component with select all checkbox and column headers
 */
const TableHeader = ({
  allSelected,
  indeterminate,
  onSelectAll,
}: TableHeaderProps) => {
  return (
    <Table.Thead>
      <Table.Tr>
        <Table.Th className="header-checkbox">
          <Checkbox
            checked={allSelected}
            indeterminate={indeterminate}
            onChange={(e) => {
              e.stopPropagation();
              try {
                onSelectAll(e.currentTarget.checked);
              } catch (error) {
                console.error("Error selecting all clients:", error);
                notifications.show({
                  title: "Error",
                  message: "Failed to select all clients. Please try again.",
                  color: "red",
                });
              }
            }}
            onClick={(e) => e.stopPropagation()}
            aria-label="Select all clients"
          />
        </Table.Th>
        <Table.Th className="header-name">
          <Tooltip label="Client's full name" withArrow position="top">
            <Text span>Name</Text>
          </Tooltip>
        </Table.Th>
        <Table.Th className="header-status">
          <Tooltip
            label="Current status of the client's tax return workflow"
            withArrow
            position="top"
            multiline
            w={220}
          >
            <Text span>Client Status</Text>
          </Tooltip>
        </Table.Th>
        <Table.Th className="header-organizer">
          <Tooltip
            label="Status of the client's tax organizer completion"
            withArrow
            position="top"
            multiline
            w={220}
          >
            <Text span>Organizer Status</Text>
          </Tooltip>
        </Table.Th>
        <Table.Th className="header-assignee">
          <Tooltip
            label="Team member assigned to this client"
            withArrow
            position="top"
          >
            <Text span>Assignee</Text>
          </Tooltip>
        </Table.Th>
      </Table.Tr>
    </Table.Thead>
  );
};

export default TableHeader;
